"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbDRPicasoSession = void 0;
const cc_1 = require("../cc");
const types_1 = require("../cc/types");
const events_1 = require("../../../security/events");
const timeOut_helper_1 = require("../../../security/timeOut/helpers/timeOut.helper");
class MbDRPicasoSession extends cc_1.MbCCSession {
    constructor() {
        super(...arguments);
        this.isDataValid = (data) => {
            if (data.entrypoint === types_1.EntrypointType.DRPicaso && data.agentToken) {
                return true;
            }
            return false;
        };
        this.getHeaders = () => {
            const data = this.getData();
            return {
                accessToken: data?.agentToken ?? '',
            };
        };
        this.doRefresh = async () => {
            if (!this.xhr) {
                throw Error('Set xhr before use DRPicasoSession');
            }
            try {
                (0, events_1.publishRefreshingSessionEvent)();
                const actualSessionCCInfo = {
                    refreshToken: this.getData()?.refreshToken,
                    username: this.getData()?.username,
                };
                const headers = this.getHeaders();
                const { data: { accessToken, refreshToken, agentToken, username, expiresIn, entrypoint }, } = await this.xhr.POST(`${window.MIDDLEWARE_BASE_HOST}/mb-api-auth/authentication/refresh-token`, actualSessionCCInfo, { headers });
                const newSessionCCData = {
                    ...this.getData(),
                    accessToken,
                    agentToken,
                    refreshToken: refreshToken ?? actualSessionCCInfo.refreshToken,
                    username: username ?? actualSessionCCInfo.username,
                    expiresIn,
                    timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(expiresIn),
                    entrypoint,
                };
                (0, events_1.publishRefreshedSessionEvent)(newSessionCCData);
                return Promise.resolve(newSessionCCData);
            }
            catch (e) {
                (0, events_1.publishErrorRefreshingSessionEvent)(e);
                throw e;
            }
        };
        this.doAgentRefresh = async () => {
            if (!this.xhr) {
                throw Error('Set xhr before use Session');
            }
            try {
                (0, events_1.publishRefreshingSessionEvent)();
                const agentToken = await this.usd?.getMethods().getAgentAccessToken();
                const newSessionData = {
                    ...this.getData(),
                    agentToken: agentToken,
                };
                (0, events_1.publishRefreshedSessionEvent)(newSessionData);
                return Promise.resolve(newSessionData);
            }
            catch (e) {
                this.finishSession();
                (0, events_1.publishErrorRefreshingSessionEvent)(e);
                throw e;
            }
        };
    }
    onRefreshToken(callback) {
        return (0, events_1.subscribeRefreshedSessionEvent)(callback);
    }
    onRefreshTokenError(callback) {
        return (0, events_1.subscribeErrorRefreshingSessionEvent)(callback);
    }
    onRefreshingToken(callback) {
        return (0, events_1.subscribeRefreshingSessionEvent)(callback);
    }
}
exports.MbDRPicasoSession = MbDRPicasoSession;
//# sourceMappingURL=index.js.map